import { Input } from '../../../components/Input/Input'
import { Animation, Button, ButtonsContainer, Flex, ItemsGrid, TabFooter } from '../../../styling/GlobalStyles'
import { CancelBtn } from 'components/Button/CancelBtn'
import { ISelectValue } from 'constants/globalTypes'
import { IItemsTab } from 'types/inventory.interface'
import { HonestSelectAsyncInput } from 'components/HonestAsyncSelect/HonestAsyncSelectInput'

export const InventoryItemsReplenishmentTab = ({
  state,
  setState,
  setActive,
}: IItemsTab) => {

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target
    setState((prev) => ({ ...prev, [name]: value }))
  }

  const handleSelect = async (value: ISelectValue, name: string) => {
    const copy = structuredClone(state)
    copy[name] = value
    setState(copy)
  }


  const handleNext = () => {
    setActive('Financial')
  }


  return (
    <Animation>

      <Flex column width='100%' >
        <ItemsGrid columns={3} gap='1rem'>
          <HonestSelectAsyncInput
            link='inventory-suppliers'
            name='preferredSupplier'
            labelText='Supplier'
            placeholder='Select Supplier'
            defaultValue={state?.preferredSupplier?.label}
            onChange={handleSelect}
            parserFunction={(data: any) => data.data.map((i: any) => ({ label: i.name, value: i.id }))}
            nomarg
          />
          <Input
            value={state?.reorderPoint}
            name='reorderPoint'
            onChange={handleChange}
            type='number'
            placeholder='15'
            labelText='Reorder Point'
          />

          <Input
            value={state?.leadTimeDays}
            name='leadTimeDays'
            onChange={handleChange}
            type='number'
            placeholder='15'
            labelText='Lead Time Days'
          />
          <Input
            value={state?.minLevel}
            name='minLevel'
            onChange={handleChange}
            type='number'
            placeholder='Enter minimum level'
            labelText='Minimum Level'
          />
          <Input
            value={state?.maxLevel}
            name='maxLevel'
            onChange={handleChange}
            type='number'
            placeholder='Enter maximum level'
            labelText='Maximum Level'
          />

        </ItemsGrid>
      </Flex>



      <TabFooter >
        <ButtonsContainer>
          <CancelBtn />
          <Button orange onClick={handleNext}>
            Next
          </Button>
        </ButtonsContainer>
      </TabFooter>
    </Animation>
  )
}
